import { PackageType } from '../../src/__generated__/api/types';

export const getPackageTypeFromSymbol = (packageType?: string) => {
  const packageTypeMap = {
    fh: PackageType.FLIGHT_HOTEL,
    fhc: PackageType.FLIGHT_HOTEL_CAR,
    fc: PackageType.FLIGHT_CAR
  };

  return packageTypeMap[packageType];
};

export const getPackageTypeSymbol = (packageType?: PackageType) => {
  const packageTypeMap = {
    FLIGHT_HOTEL: 'fh',
    FLIGHT_HOTEL_CAR: 'fhc',
    FLIGHT_CAR: 'fc'
  };

  return packageTypeMap[packageType];
};
